import { useAppSelector } from 'store/hooks';
import { selectUserData } from 'store/user/selectors';

export const SUPER_ADMIN_ROLE = 'super_admin';

/**
 * True when the signed-in admin has the BE `super_admin` role. This is distinct
 * from usePermission().isSuperAdmin (which is the id === ADMIN_USER_ID bypass);
 * super_admin-gated BE endpoints key on the role, not the id.
 *
 * READ role_name FIRST. /auth/me sets `role` to the literal 'admin' for every
 * admin (sanitizeAdmin) and carries the real role in `role_name`, so checking
 * `role` first makes this always false — including for the superadmin.
 */
const useIsSuperAdminRole = (): boolean => {
  const user = useAppSelector(selectUserData());
  const role = user?.role;
  const name =
    user?.role_name ?? (typeof role === 'string' ? role : role?.name);

  return name === SUPER_ADMIN_ROLE;
};

export default useIsSuperAdminRole;
